var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('img',{style:({'height': _vm.fontSize}),attrs:{"src":_vm.getUrl()}})])}
var staticRenderFns = []

export { render, staticRenderFns }